export function NoData () {
    return (
        <div className={"noData"}>Нет данных для показа</div>
    )
}